<form [formGroup]="addressForm">
  <div class="modal-header">
    <h1>Redemption Address</h1>
  </div>
  <div class="modal-body">
    <div class="alert alert-danger alert-dismissable" *ngIf="errorMsg">
      {{errorMsg}}
      <a (click)="clearErrorMessage()">
        <span class="float-right close-button">
          <fa-icon [icon]="faTimes"></fa-icon>
        </span>
      </a>
    </div>
    <div class="row">
      <div class="col-md-12 redemption-modal">
        <div class="form-group">
          <label>Address Line 1</label>
          <input type="text" class="form-control" formControlName="address1" autofocus="autofocus" />
        </div>
        <div class="form-group">
          <label>Address Line 2</label>
          <input type="text" class="form-control" formControlName="address2" />
        </div>
        <div class="form-group">
          <label>City</label>
          <input type="text" class="form-control" formControlName="city" />
        </div>
        <div class="form-group">
          <label>State</label>
          <div #statesRef>
            <ng-autocomplete 
              #states (inputFocused)="focusStates()" 
              formControlName="state" 
              searchKeyword="displayText"
              keyProperty="code" 
              [data]="addressData.states" 
              historyIdentifier="states" 
              [itemTemplate]="stateTemplate"
              [notFoundTemplate]="notFoundTemplate" 
              (selected)="onStateSelected($event)"
              (inputChanged)="onInputChanged($event)" 
              debounceTime="500">
            </ng-autocomplete>
          </div>
          <div class="mt-1" [hidden]="addressForm.controls.state.valid">
            <small class="text-danger">Invalid State Selection</small>
          </div>
        </div>
        <div class="form-group">
          <label>Zip</label>
          <input type="text" class="form-control" formControlName="zip" />
        </div>
        <div class="form-group">
          <label>Country</label>
          <input type="text" class="form-control" formControlName="country" />
        </div>
      </div>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-dark-blue" type="submit" (click)="ok()" [disabled]="!addressForm.valid || isDisabledSave">
      <fa-icon [icon]="faSave"></fa-icon>
    </button>
    <button class="btn btn-attention" type="button" (click)="cancel()">
      <fa-icon [icon]="faTimes"></fa-icon>
    </button>
  </div>
</form>

<ng-template #stateTemplate let-item>
  <a [innerHTML]="item.displayText"></a>
</ng-template>

<ng-template #notFoundTemplate let-notFound>
  <div [hidden]="addressForm.controls.state.errors?.invalidState" [innerHTML]="notFound"></div>
</ng-template>